import { usageTrackSectionTap } from 'Webapp/shared/app/redux/actions/usage-actions';

export default {
  actions: { usageTrackSectionTap },
};
